const About = () => {
    return (
        <section className="About container h-[550px] bg-aboutBack bg-cover relative bottom-11">
            <div className=" h-full bg-[rgba(0,0,0,0.6)] text-slate-50 flex flex-wrap justify-around items-center">
                <h3 className="text-4xl font-bold w-full text-center">مرکز اسناد علمی و اطلاع رسانی دانشگاه تخصصی فناوری های نوین آمل</h3>
                <div className="text-4xl font-bold text-center">
                    +400 <p>جلد کتاب</p>
                </div>
                <div className="text-4xl font-bold text-center">
                    +500 <p>جلد پایان نامه</p>
                </div>
                <div className="text-4xl font-bold text-center">
                    +100 <p>جلد نشریه</p>
                </div>
            </div>
        </section>
    );
};

export default About;
